import React from "react";
import clsx from "clsx";

import { formatLeaveType } from "../../../utils/helpers.ts";
import styles from "./leave-type-label.module.css";

const LABELS = {
  leave: "Leave",
  wfh: "WFH",
  "in-office": "In Office",
} as const;

function formatLeaveLabel(type?: string) {
  if (!type) return "";
  return formatLeaveType(type);
}

export type LeaveTypeLabelVariant = keyof typeof LABELS;

export interface LeaveTypeLabelProps {
  variant: LeaveTypeLabelVariant;
  /** Overrides default text for this variant (same colors apply). */
  label?: string;
  className?: string;
}

export function LeaveTypeLabel({
  variant,
  label,
  className,
}: LeaveTypeLabelProps) {
  const variantClass =
    variant === "leave"
      ? styles.leave
      : variant === "wfh"
        ? styles.wfh
        : styles.inOffice;

  return (
    <p className={clsx(styles.root, variantClass, className)}>
      {formatLeaveLabel(label) || LABELS[variant]}
    </p>
  );
}
